import React, { useRef, useState } from 'react'
import { Button } from '~/lib/ui/button'
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogAction,
  AlertDialogCancel,
} from '~/lib/ui/alert-dialog'
import { apiDelete } from '~/util/api'
import RichTextEditor from '~/lib/ui/rich-text-editor'
import Quill from 'quill'
import { useCandidate } from './CandidateProvider'
import { useTranslation } from '~/hooks/useTranslation'

const CancelMeetingModal = ({
  serviceRequest,
  onSuccess = () => {},
  children,
}) => {
  const { t } = useTranslation('CancelMeetingModal')
  const {
    id: serviceRequestId,
    candidateFirstName,
    displayName,
    pendingEvents,
  } = serviceRequest || {}

  const [isOpen, setIsOpen] = useState(false)
  const { coachFirstName } = useCandidate()
  const editorRef = useRef(null)
  const defaultMessage = {
    ops: [
      {
        insert: t('cancellation_message', {
          candidateFirstName,
          coachFirstName,
        }),
      },
    ],
  }

  const quillTemp = document.createElement('div')
  const quillInstance = new Quill(quillTemp)
  quillInstance.setContents(defaultMessage)

  const calendlyEvent = pendingEvents?.[0]

  if (!calendlyEvent) return null

  const handleCancelMeeting = async () => {
    const data = {
      service_request_id: serviceRequestId,
      cancellation_message: editorRef?.current?.getSemanticHTML(),
    }
    try {
      const response = await apiDelete('/coach/cancel_meeting', { data })
      if (response.status === 200) {
        onSuccess()
        return
      }
    } catch (error) {
      console.error('Error cancelling meeting:', error)
    }
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogTrigger asChild>
        <Button
          variant="link"
          className="justify-start font-normal text-intoo-blue-medium hover:text-link"
        >
          {children}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="font-roboto">
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Meeting</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="max-h-[80vh] overflow-y-auto px-4">
          <p>
            Are you sure you want to cancel the <strong>{displayName}</strong>{' '}
            with <strong>{candidateFirstName}</strong>? Do not take this action
            to mark this meeting as a No-Show.
          </p>
          <label className="mb-2 mt-4 block text-sm font-medium">
            Please write a message to the candidate explaining the cancellation
            below before confirming.
          </label>
          <RichTextEditor
            className="mt-4 h-[425px]"
            ref={editorRef}
            defaultValue={defaultMessage}
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="outline">Close</Button>
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleCancelMeeting} asChild>
            <Button>Confirm</Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
export default CancelMeetingModal
